/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_NInputs */

const en_tut_denah_n = /** @type {(inputs: Tut_Denah_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limits: 30 areas, 200 desks, 1–50 people per area, and exactly one public lobby. Publishing a new plan cuts nearby audio and can end area conversations in progress — publish while the office is quiet.`)
};

const id_tut_denah_n = /** @type {(inputs: Tut_Denah_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas: 30 area, 200 meja, kapasitas 1–50 orang per area, dan tepat satu lobi publik. Menerbitkan denah baru memutus audio sekitar dan dapat mengakhiri percakapan area yang sedang berjalan — terbitkan saat kantor sedang sepi.`)
};

/**
* | output |
* | --- |
* | "Limits: 30 areas, 200 desks, 1–50 people per area, and exactly one public lobby. Publishing a new plan cuts nearby audio and can end area conversations in pr..." |
*
* @param {Tut_Denah_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_n = /** @type {((inputs?: Tut_Denah_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_n(inputs)
	return en_tut_denah_n(inputs)
});